module.exports = __webpack_public_path__ + "static/media/rocket2.5d590f77.jpg";